import React, { Component } from 'react'
import getManageUsersStartCardRoute from '../../../helpers/users/manageUsers/getManageUsersStartCardRoute';

class ManageUsersRedirect extends Component {
  componentDidMount() {
    if (this.props.user) {
      this.navToManageUsersStartCard()
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user && this.props.user) {
      this.navToManageUsersStartCard()
    }
  }

  navToManageUsersStartCard = () => {
    const { user, history } = this.props
    const route = getManageUsersStartCardRoute(user)
    history.push(route)
  }
  
  render() {
    return <div></div>
  }
}

export default ManageUsersRedirect


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManageUsersRedirect.js